import {
  PriceSummary,
  PriceSummaryRow
} from '@ps-design-system/components/PriceSummary';
import { Text } from '@ps-design-system/components/Text';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { AttendeePricingSummary } from './AttendeePricingSummary';
import { CalendarPricingSummaryRows } from './CalendarPricingSummaryRows';

export const PricingRulesSummary = ({
  pricingRules,
  calendarPricingRules,
  currency
}) => {
  return (
    <div>
      <Text typeface="headline-1-m" element="p" style={{ margin: '0 0 8px 0' }}>
        <FormattedMessage
          id="pricing_rules_summary.hourly_rates"
          defaultMessage="Hourly Rates"
        />
      </Text>
      <PriceSummary testId="booking-request-price-summary" textSize="large">
        <PriceSummaryRow
          testId="pricing-rules-summary-base-rate"
          name={(
            <FormattedMessage
              id="pricing_rules_summary.base_rate"
              defaultMessage="Base rate"
            />
          )}
          value={(
            <FormattedMessage
              id="pricing_rules_summary.base_rate_value"
              defaultMessage="{rate}/hr"
              values={{
                rate: (
                  <FormattedNumber
                    value={200}
                    style="currency"
                    currency={currency}
                  />
                )
              }}
            />
          )}
        />

        {calendarPricingRules?.length > 0 && (
          <CalendarPricingSummaryRows
            calendarPricingRules={calendarPricingRules}
            currency={currency}
          />
        )}
      </PriceSummary>

      {pricingRules?.attendee_pricing?.tiers?.length > 0 && (
        <>
          <Text
            typeface="headline-1-m"
            element="p"
            style={{ margin: '32px 0 8px 0' }}
          >
            <FormattedMessage
              id="pricing_rules_summary.attendee_pricing"
              defaultMessage="Attendee pricing"
            />
          </Text>
          <AttendeePricingSummary
            attendeePricingTiers={pricingRules.attendee_pricing.tiers}
            currency={currency}
          />
        </>
      )}
    </div>
  );
};
PricingRulesSummary.displayName = 'PricingRulesSummary';
PricingRulesSummary.propTypes = {
  pricingRules: PropTypes.object,
  calendarPricingRules: PropTypes.array,
  currency: PropTypes.string
};
